import { Menu } from '@headlessui/react';
import IconMore from '@components/icons/IconMore';
import useToggle from '@hooks/useToggle';
import cn from '@utils/cn';
import { flip, useFloating } from '@floating-ui/react-dom';

export function MoreMenu<T extends readonly string[]>({
  items,
  className,
  scheme = 'light',
  onSelect,
}: {
  items: T;
  className?: string;
  scheme?: 'light' | 'dark';
  onSelect: (val: T[number]) => void;
}) {
  const toggle = useToggle(false);
  const {
    x: posX,
    y: posY,
    reference,
    floating,
    strategy,
  } = useFloating({
    middleware: [flip()],
    placement: 'bottom',
    strategy: 'fixed',
  });

  return (
    <Menu
      as="div"
      className={cn('relative shrink-0', className)}
      onMouseEnter={toggle.on}
      onMouseLeave={toggle.off}
    >
      <Menu.Button as="div" ref={reference}>
        <IconMore
          scheme={scheme}
          className="rotate-90"
          onClick={(e) => {
            e.stopPropagation();
            toggle.toggle();
          }}
        />
      </Menu.Button>
      {toggle.isOn && (
        <Menu.Items
          static
          ref={floating}
          style={{
            position: strategy,
            top: posY ?? '',
            left: posX ?? '',
          }}
          className="z-50 pt-5 focus:outline-none"
        >
          <div className="overflow-hidden rounded border bg-white p-10 text-black focus:outline-none">
            {items.map((x) => (
              <Menu.Item key={x}>
                <div
                  className="flex h-30 cursor-pointer items-center justify-center rounded px-10 hover:bg-[#efefef]"
                  onClick={(e) => {
                    e.stopPropagation();
                    toggle.off();
                    onSelect(x);
                  }}
                >
                  {x}
                </div>
              </Menu.Item>
            ))}
          </div>
        </Menu.Items>
      )}
    </Menu>
  );
}

export default MoreMenu;
